import { GlobalCustomConfigurator } from './components/GlobalCustomConfigurator';

export { GlobalCustomConfigurator };
